export default {"src":"/_next/static/media/twitter.695e9659.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};